import { Component, ElementRef, AfterViewInit, OnInit, ViewChild } from '@angular/core';
import { MemberDetails, MemberQuery, PopulationQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { calculateAge, getKidType, KidTypeE, KidTypeT } from 'src/app/shared/utilities/age-ranges';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-home-navigation',
  templateUrl: './home-navigation.component.html',
  styleUrl: './home-navigation.component.scss',
})
export class HomeNavigationComponent implements OnInit, AfterViewInit {
  member$: Observable<MemberDetails | undefined>;
  memberDetails$: Observable<{ kidType: KidTypeT }>;
  KidType = KidTypeE;
  isScrollEnd = false;
  isClub1901 = false;
  populations: Populations;

  @ViewChild('navScroll') navScrollRef!: ElementRef<HTMLElement>;

  constructor(private memberQuery: MemberQuery, private populationQuery: PopulationQuery) { }

  ngOnInit() {
    this.isClub1901 = this.populationQuery.userInPopulation([Populations.Club1901]);
    this.member$ = this.memberQuery.selectMemberDetails();
    this.memberDetails$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
        const age = m ? calculateAge(new Date(m.DOB)) : 0;
        return { kidType: getKidType(age) };
      })
    );
  }

  ngAfterViewInit() {
    this.checkScrollEnd(this.navScrollRef.nativeElement);
  }

  onNavScroll(event: Event) {
    this.checkScrollEnd(event.target as HTMLElement);
  }

  private checkScrollEnd(el: HTMLElement) {
    this.isScrollEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
  }
}
